/* eslint-disable react/destructuring-assignment */
import { components as RsComponents, defaultTheme } from 'react-select';
import styled from 'styled-components';
import { UserTag } from './select';

export const StyledDropdownIndicator = styled(
  RsComponents.DropdownIndicator,
).attrs({
  theme: {
    ...defaultTheme,
  },
})``;

export const DropdownIndicator = (props: any) => (
  <StyledDropdownIndicator {...props} />
);

export const StyledControl = styled(RsComponents.Control).attrs({
  theme: {
    ...defaultTheme,
    borderRadius: 0,
  },
})``;

export const Control = (props: any) => <StyledControl {...props} />;

export const ClearIndicator = (props: any) => (
  <RsComponents.ClearIndicator {...props} />
);

export const StyledMultiValue = styled(RsComponents.MultiValue).attrs({
  theme: {
    ...defaultTheme,
    borderRadius: 0,
  },
})``;

export const SingleUserValue = ({ data, ...props }: any) => (
  <RsComponents.SingleValue {...props}>
    <UserTag {...data} />
  </RsComponents.SingleValue>
);

export const MultiValue = (props: any) => <StyledMultiValue {...props} />;

export const StyledMultiValueLabel = styled(RsComponents.MultiValueLabel).attrs(
  {
    theme: {
      ...defaultTheme,
      borderRadius: 0,
    },
  },
)``;

export const MultiValueLabel = (props: any) => (
  <StyledMultiValueLabel {...props}>
    <UserTag {...props.data} />
  </StyledMultiValueLabel>
);

export const StyledMultiValueRemove = styled(
  RsComponents.MultiValueRemove,
).attrs({
  theme: {
    ...defaultTheme,
    borderRadius: 0,
  },
})``;

export const MultiValueRemove = ({ data, ...props }: any) => (
  <StyledMultiValueRemove {...props} />
);

export const AvatarOption = (props: any) => (
  <RsComponents.Option {...props}>
    <UserTag {...props.data} />
  </RsComponents.Option>
);

export const TagOption = (props: any) => (
  <RsComponents.Option {...props}>
    <UserTag {...props.data} />
  </RsComponents.Option>
);

export const TagSingleValue = (props: any) => (
  <RsComponents.SingleValue {...props}>
    <UserTag {...props.data} />
  </RsComponents.SingleValue>
);
